import(/* webpackMode: "eager" */ "/vercel/path0/web/app/(main)/menneskene/page.tsx");
